import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";

export default function RoomDetails() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const images = data?.image ? data.image.split(",") : [];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    setUser(loginUser);

    if (loginUser) {
      const savedWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

      setWishlist(savedWishlist);
    }
  }, []);

  // Wishlist Sync
  useEffect(() => {
    const syncWishlist = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));

      if (loginUser) {
        const saved =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

        setWishlist(saved);
        setUser(loginUser);
      }
    };

    window.addEventListener("cartUpdated", syncWishlist);
    window.addEventListener("storage", syncWishlist);

    return () => {
      window.removeEventListener("cartUpdated", syncWishlist);
      window.removeEventListener("storage", syncWishlist);
    };
  }, []);

  // Fetch Room Details
  useEffect(() => {
    fetch(`${API.LIST_ACTIVE_WORKSPACES}`)
      .then((res) => res.json())
      .then((result) => {
        const selected = result.find((item) => item.id == id);
        setData(selected);
      });
  }, [id]);

  // Wishlist Toggle
  const toggleLike = () => {
    if (!user) {
      alert("Please login first");
      return;
    }

    let updatedWishlist = [...wishlist];

    const exists = updatedWishlist.find((item) => item.id === data.id);

    if (exists) {
      updatedWishlist = updatedWishlist.filter((item) => item.id !== data.id);
    } else {
      updatedWishlist.push({
        ...data,
        type: "workspace",
      });
    }

    setWishlist(updatedWishlist);

    localStorage.setItem(
      `wishlist_${user.id}`,
      JSON.stringify(updatedWishlist),
    );

    window.dispatchEvent(new Event("cartUpdated"));
  };

  // Loading
  if (!data) {
    return (
      <div className="container text-center mt-5">
        <h4>No Room Data Found</h4>

        <button className="btn btn-primary" onClick={() => navigate("/house")}>
          Back to Listings
        </button>
      </div>
    );
  }

  return (
    <div className="container-fluid product-page">
      <div className="row">
        <div className="mb-3">
          <button
            className="btn btn-light back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left"></i> Back
          </button>
        </div>

        {/* ================= LEFT IMAGE ================= */}

        <div className="col-lg-5">
          <div className="product-image-section">
            <img
              src={`${UPLOADS.WORKSPACE_IMAGE}${images[currentIndex]}`}
              className="product-main-img"
              alt="Workspace"
              onError={(e) => (e.target.src = "/img/no-image.png")}
            />

            {/* Thumbnails */}

            {images.length > 1 && (
              <div className="thumbnail-wrapper mt-2">
                {images.map((img, index) => (
                  <img
                    key={index}
                    src={`${UPLOADS.WORKSPACE_IMAGE}${img}`}
                    onClick={() => setCurrentIndex(index)}
                    className={`thumbnail-img ${
                      currentIndex === index ? "active-thumb" : ""
                    }`}
                    alt="thumbnail"
                  />
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ================= CENTER INFO ================= */}

        <div className="col-lg-4">
          <div className="product-card1">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h2 className="product-title">{data.city} Workspace</h2>

                <h3 className="product-price">
                  ₹{Number(data.rent_price).toLocaleString("en-IN")}
                  <small
                    style={{
                      fontSize: "14px",
                      color: "#666",
                    }}
                  >
                    / month
                  </small>
                </h3>
              </div>

              <button className="like-btn" onClick={toggleLike}>
                <i
                  className={
                    wishlist.some((w) => w.id === data.id)
                      ? "bi bi-heart-fill text-danger"
                      : "bi bi-heart"
                  }
                ></i>
              </button>
            </div>

            <p className="mt-3">
              <strong>Size:</strong> {data.size}
            </p>

            <p className="product-desc">{data.description}</p>

            <a
              href={`https://wa.me/91${data.phone}`}
              target="_blank"
              rel="noreferrer"
              className="btn btn-success w-100 mt-3 py-2"
            >
              <i className="bi bi-whatsapp me-2"></i>
              Contact Owner
            </a>
          </div>

          {/* Tabs */}

          <div className="mt-4">
            <ul className="nav nav-tabs custom-tabs">
              <li className="nav-item">
                <button
                  className="nav-link active"
                  data-bs-toggle="tab"
                  data-bs-target="#roomInfo"
                >
                  Room Specs
                </button>
              </li>

              <li className="nav-item">
                <button
                  className="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#ownerInfo"
                >
                  Owner Info
                </button>
              </li>
            </ul>

            <div className="tab-content">
              {/* ROOM INFO */}

              <div className="tab-pane fade show active tab-box" id="roomInfo">
                <table className="info-table">
                  <tbody>
                    <tr>
                      <th>Size</th>
                      <td>{data.size}</td>
                    </tr>

                    <tr>
                      <th>Floor</th>
                      <td>{data.floor}</td>
                    </tr>

                    <tr>
                      <th>Address</th>
                      <td>{data.address}</td>
                    </tr>
                    <tr>
                      <th>Landmark</th>
                      <td>{data.location}</td>
                    </tr>

                    <tr>
                      <th>City</th>
                      <td>{data.city}</td>
                    </tr>

                    <tr>
                      <th>State</th>
                      <td>{data.state}</td>
                    </tr>

                    <tr>
                      <th>Rent</th>
                      <td>₹{data.rent_price}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* OWNER INFO */}
              <div className="tab-pane fade tab-box" id="ownerInfo">
                <table className="info-table">
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td>{data.owner_name}</td>
                    </tr>
                    <tr>
                      <th>Address</th>
                      <td>{data.address}</td>
                    </tr>
                    <tr>
                      <th>Landmark</th>
                      <td>{data.location}</td>
                    </tr>
                    <tr>
                      <th>Phone</th>
                      <td>{data.phone}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT ADS */}

        <div className="col-lg-3">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
            <h5 className="ads-title">Sponsored</h5>

            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>

              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
